import { render, staticRenderFns } from "./LocationTypes.vue?vue&type=template&id=c2a93f28&"
import script from "./LocationTypes.vue?vue&type=script&lang=js&"
export * from "./LocationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports